/**
 * Queries GraphQL pour les Audit Logs
 */

import { gql } from '@apollo/client';

/**
 * Get paginated audit logs
 */
export const GET_AUDIT_LOGS = gql`
  query GetAuditLogs(
    $filter: AdminAuditFilterInput
    $page: Int
    $pageSize: Int
  ) {
    adminAuditLogs(filter: $filter, page: $page, pageSize: $pageSize) {
      items {
        id
        timestamp
        userId
        userEmail
        userRole
        userIp
        userAgent
        enterpriseId
        departmentId
        action
        actionLabel
        resource
        resourceId
        resourceLabel
        oldValue
        newValue
        module
        endpoint
        method
        metadata
        success
        errorMessage
      }
      total
      page
      pageSize
    }
  }
`;

/**
 * Get audit log statistics
 */
export const GET_AUDIT_STATS = gql`
  query GetAuditStats($startDate: Date, $endDate: Date) {
    adminAuditStats(startDate: $startDate, endDate: $endDate) {
      totalActions
      errorsCount
      topModule
      todayCount
      actionDistribution
    }
  }
`;

/**
 * Get audit log summary for dashboard
 */
export const GET_AUDIT_SUMMARY = gql`
  query GetAuditSummary {
    adminAuditSummary {
      totalLogs
      last24h
      last7days
      errorRate
      mostActiveUsers
      moduleBreakdown
    }
  }
`;
